/**
 * Game Controller Class
 *
 * Handles the main game flow
 *
 * Also has some specific cascade reels functionality here
 */

/* module manages the main game this inherits from spinFunctions */

gameController = (function () {
  var _payWinsEvent = {};
  var _poppingSymbols = [];
  var _dropEvent = [];
  var _dropsRemaining = 0;
  var _reelToFrespinsBarFlying = 0;
  var _popAndDropCompleteEvent = 0;
  var _totalWinnings = 0;
  var _numberOfPops = 0;
  var _jackpotTask;
  var _currentTime;
  var _featureAwarded = false;
  var _animWinsFinished = false;
  var _singleAnimWinFinished = false;
  var _skipWin = false;
  var _bonusSymbolsLanded = 0;
  var _initialDropping = 0;
  var _bigWin = undefined;
  var _inBuyABonus = false;
  var _specialEvent = false;
  var inBuyABonusRecovery = false;
  var _inBuyASuperBonus = false;
  var inRecovery = false;
  var _popData = [];
  var _allPopsComplete = false;
  var _symbolDisappearAnims = [];
  var _wildBlastAnims = [];
  var _landedAnimsPlaying = [];
  var _symbolCallbackFired = [];
  var multiplierViewLeft = undefined;
  var multiplierViewRight = undefined;
  var logoIdleTimeline = undefined;
  var titleAnim = undefined;
  var extraLifePopup = undefined;
  var _freeSpinsMeter = undefined;
  var _modifierEventTriggered = false;
  var _spinBonusSounds = [
    "bonusLand1",
    "bonusLand2",
    "bonusLand3",
    "bonusLand4",
    "bonusLand5",
  ];

  function resetWinnings() {
    _totalWinnings = 0;
    _numberOfPops = 0;
  }

  function jackpotGame(task) {
    _jackpotTask.join();

    _bigWin.start(task.data.value, function () {
      _jackpotTask.leave();
    });
  }

  function recoverGame(task) {
    // Recovery game with encore
    if (
      task.data.metaData === "encore" &&
      gameData.encoreEnabled !== task.data.metaValue
    ) {
      // Clear any encore effects and stop them appearing again
      gameData.encoreEnabled = task.data.metaValue;

      // Put button in the right state if not already true
      var encoreButtonLB = resourceManager.get(
        "buttonContainer:buttonBar:luckyBetToggleButton"
      );

      if (encoreButtonLB._flags.showLuckyBetActive !== gameData.encoreEnabled) {
        encoreButtonLB.setRecovery();
      }

      var trailType = gameData.encoreEnabled ? "trailX3" : "trailX4";
      resourceManager.get("trail:TrailContainer").switchTrail(trailType);
    }

    inRecovery = true;

    if (task.data.metaData === "buyABonus" && task.data.metaValue) {
      gameController.inBuyABonus = true;
      inBuyABonusRecovery = true;
      initNewSpin();
    } else if (task.data.metaData === "buyASuperBonus" && task.data.metaValue) {
      gameController.inBuyASuperBonus = true;
    } else {
      initNewSpin();
    }
  }

  function updateStake() {
    let stakeController = resourceManager.getController("stakeController");
    let baseStake = stakeController.BaseStake;
    let bpl = baseStake / 25;
    let luckyBetEnabled = gameData.encoreEnabled;

    stakeController.setStakeMultiplier(luckyBetEnabled ? 1.5 : 1);
    game.changeStake(baseStake * (luckyBetEnabled ? 1.5 : 1), bpl);
    stakeController.broadcastCurrentStake();
  }

  function onPromotionStarted() {
    _isPromotion = true;
  }

  function onPromotionEnded() {
    _isPromotion = false;
  }

  function canEnableSkip() {
    return (
      gameController.stateMachine.ActiveStateName === "PAYWINS" && !_skipWin
    );
  }

  function initNewSpin() {
    // Start of new game
    gameController._receivedResponse = false;

    gameController.resetWinnings();

    musicManager.onGameStart();

    gameController.reelsSpinning = [false, false, false, false, false]; //gameData.reels.length;
    gameData.winningsMeter.set(0);

    var config = resourceManager.get("slotContainer").Props.configValues;

    gameData.reels.forEach(function (value) {
      value.setSpinParameters({
        spinSpeed: config.spinSpeed,
        landOffset: config.landOffset,
        decelerationDistance: config.decelerationDistance,
      });
    });

    _payWinsEvent = undefined;
    gameController.spinTask = undefined;

    // clear reels here - then spin event will cause the new symbols to drop in
    slotMachine.clearReels();

    // this needs to go to an intermediate state until the drop is finished - then into reels_spinning
    //gameController.stateMachine.switchState("REELS_SPINNING");
    gameController.stateMachine.switchState("CLEAR_REELS");

    // Update autoplay button text
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr =
      spinsRemaining > 0 ? String(spinsRemaining - 1) : "∞";

    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", spinsRemainingStr);
  }

  function startGame() {
    // Do not allow the user to spin if the buy bonus present is up
    let buyBonusPopUp = resourceManager.get("buyABonusContainer:buyBonusPopup");

    if (buyBonusPopUp.visible) return;

    resourceManager.get("MinerView").stopIdleAnims();

    initNewSpin();

    var stakeController = resourceManager.getController("stakeController");
    let bpl = stakeController.BaseStake / stakeController.CurrentWinLineCount;

    gdk.startGame(
      {
        //numbers should came from the stake controller
        stake: stakeController.CurrentStake,
        numWinlines: stakeController.CurrentWinLineCount,
        bpl: bpl,
        metaData: {
          encore: gameData.encoreEnabled,
          buyABonus: false,
        },
      },
      function () {
        gdk.getNextGameOutcome(function () {});
      }
    );
  }

  function onAbortGame() {
    var slotMachine = GameSlotMachineFactory.getSlotMachine(0);

    // game aborted - reset reels to startup symbols
    for (var i = 0; i < slotMachine.reels.length; i++) {
      let reel = resourceManager.get("slotContainer:reelContainer:reel" + i);
      let startingSymbols = gameData.slotConfig.startingSymbols[i].symbols;
      let reelLength = gameData.slotConfig.startingSymbols[i].symbols.length;

      // Copy starting symbols from server
      for (var j = 0; j < reelLength; ++j) {
        reel.setReelSymbol(j, startingSymbols[j].value);

        // make sure the reel symbols are in the correct position
        reel.dropInitialSymbols(j, 1);
      }

      // just for completeness the off screen symbol
      reel.dropInitialSymbols(3, 1);
    }

    gameController.stateMachine.switchState("WAITING_FOR_SERVER");
  }

  function doPayWins(payWinsEvent) {
    _payWinsEvent = payWinsEvent;
    _payWinsEvent.join();
    _numberOfPops++;

    /// TODO SA Win levels may need tweaking
    if (!freespins.inFreespins /*!freespins.areFreeSpinsActive()*/) {
      if (_numberOfPops >= 3) {
        musicManager.fadeLevels(
          musicManager.REALLYBIGWINLEVEL,
          musicManager.fadeLevelTimeIn,
          musicManager.fadeLevelTimeOut,
          1,
          0
        );
      } else if (_numberOfPops === 2) {
        musicManager.fadeLevels(
          musicManager.MULTIWINLEVEL,
          musicManager.fadeLevelTimeIn,
          musicManager.fadeLevelTimeOut,
          1,
          0
        );
      } else if (_numberOfPops === 1) {
        musicManager.fadeLevels(
          musicManager.SINGLEWINLEVEL,
          musicManager.fadeLevelTimeIn,
          musicManager.fadeLevelTimeOut,
          1,
          0
        );
      }
    } else {
      // we do this once all cascades have finished on this spin
      //musicManager.freeSpinsNextLevel();
    }

    // Add to cumulative total winnings
    _skipWin = false;
    _totalWinnings += _payWinsEvent.data.totalLineWinnings;

    gameController.canCelebrate =
      _totalWinnings >
      resourceManager.getController("stakeController").CurrentStake;

    _extraSpinsFlyingToTotem = 0;

    //Extra Life
    if (
      _payWinsEvent?.data?.extraLivesFinal !== 0 &&
      _payWinsEvent.data.winAmount === 0
    ) {
      gameController.stateMachine.switchState("PRE_POP_SYMBOLS");
      gameController.extraLiveActive = true;
    } else {
      gameController.stateMachine.switchState("PAYWINS");
    }
  }

  function preGameComplete(gameCompleteEvent) {
    doGameComplete();
  }

  function doGameComplete() {
    gameController.inBuyABonus = false;

    if (_dropEvent?.data?.leftMultiplierFinal > 0) {
      multiplierViewLeft.resetMultiplier();
    }
    if (_dropEvent?.data?.rightMultiplierFinal > 0) {
      multiplierViewRight.resetMultiplier();
    }

    musicManager.onGameEnd();

    resourceManager.get("trail:TrailContainer").trailRunEnded();

    resourceManager.get("MinerView").playIdleAnims();
    resourceManager.get("MinerView").onIdle();

    gameController.stateMachine.switchState("END_GAME");
  }

  function autoplayStarted(autoplayData) {
    var spinsRemaining = autoplayManager.getRemainingRounds();
    var spinsRemainingStr = spinsRemaining >= 0 ? String(spinsRemaining) : "X";

    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", spinsRemainingStr);
  }

  function autoplayEnded(autoplayData) {
    resourceManager
      .getController("inputOverlord")
      .setText("autoplayCancelButton", "");
    resourceManager.get(
      "buttonContainer:buttonBar:autoplayButton:glow"
    ).visible = false;
  }

  function onPopAndDropComplete(popAndDropCompleteEvent) {
    _popAndDropCompleteEvent = popAndDropCompleteEvent;

    if (popAndDropCompleteEvent.data.winnings > 0) {
      _popAndDropCompleteEvent.join();
      gameController.stateMachine.switchState("PAY_TO_WINNINGS");
    }

    // Hiding the bonus symbol if it appears below the reels
    if (reelManager.reels[0].symbolData[3].symbolId == 9) {
      reelManager.reels[0].children[0].children[3].visible = false;
    }
    if (reelManager.reels[1].symbolData[3].symbolId == 9) {
      reelManager.reels[1].children[0].children[3].visible = false;
    }
    if (reelManager.reels[2].symbolData[3].symbolId == 9) {
      reelManager.reels[2].children[0].children[3].visible = false;
    }
    if (reelManager.reels[3].symbolData[3].symbolId == 9) {
      reelManager.reels[3].children[0].children[3].visible = false;
    }
    if (reelManager.reels[4].symbolData[3].symbolId == 9) {
      reelManager.reels[4].children[0].children[3].visible = false;
    }
  }

  function onDropEvent(dropEvent) {
    _dropEvent = dropEvent;
    _dropEvent.join();

    _specialEvent = _dropEvent?.data?.specialReward?.type;

    _bonusSymsDropComplete = false;

    gameController.stateMachine.switchState("DROP_SYMBOLS");
  }

  function onModifierEvent(modifierEvent) {
    _modifierEventTriggered = true;
  }

  function onExtraSpinsRemaining(event) {}

  function onDropComplete() {
    _dropsRemaining--;

    if (_dropsRemaining === 0) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      _dropEvent.leave();
    }
  }

  function onReelToFrespinsBarComplete() {
    _reelToFrespinsBarFlying--;
    if (_reelToFrespinsBarFlying === 0) {
      // Move onto next phase
      _allPopsComplete = true;
    }
  }

  function onFeatureAnnounced(task) {
    _featureAwarded = true;
  }

  function onFeatureEnded() {
    _featureAwarded = false;
  }

  function update(delta, time) {
    // Store time for wobble
    _currentTime = time;

    this.stateMachine.update();
  }

  function dimAllReels(dim) {
    for (var i = 0; i < reelManager.reels.length; i++) {
      reelManager.reels[i].dimAllSymbols(dim, 0x666666);
    }
  }

  function wobbleSymbol(symbol, amount, reel) {
    var prog = (_currentTime % 1000) / 1000 - reel * 0.1;
    var pos = Math.sin(Math.PI * 2 * prog) * amount;
    // TODO - decide if we still need to do this.
    //  symbol.position.set(0,pos);
  }

  //define gameController
  gameController = Object.create(spinFunctions);
  Object.defineProperties(gameController, {
    startGame: { value: startGame },
    resetWinnings: { value: resetWinnings },
    initNewSpin: { value: initNewSpin },
    totalWinnings: { value: _totalWinnings },
    doGameComplete: { value: doGameComplete },
    canEnableSkip: { value: canEnableSkip },
    isFeatureAwarded: {
      get: function () {
        return _featureAwarded;
      },
    },
    dimAllReels: { value: dimAllReels },
    inBuyABonus: {
      get: function () {
        return _inBuyABonus;
      },
      set: function (value) {
        _inBuyABonus = value;
      },
    },
  });

  gameController.resetSymbolCallbackFired = function () {
    _symbolCallbackFired = [];
  };

  gameController.cancelAutoplay = function () {
    resourceManager.getController("autoplayController").cancel();
  };

  /**
   * Set up the win flash animations
   *
   * To position this, use your symbol sizes and then move the reelsParticleLayer in layout
   *
   */
  gameController.setupSymbolDisappearAnims = function () {
    for (var i = 0; i < 5; i++) {
      var rowAnims = [];
      var wildRowAnims = [];

      for (var j = 0; j < 3; j++) {
        let posX = (i + 1) * 180;
        let posY = (j + 0.5) * 186;

        var movie = resourceManager.createObject(
          "movie",
          "symbolDisappear_" + i + "_" + j,
          "reelsParticleLayer",
          {
            definition: "symbolFlash",
            x: posX,
            y: posY,
            anchor: 0.5,
            scale: 1.0,
            loop: false,
          }
        );

        var wild = resourceManager.createObject(
          "movie",
          "wildBlast" + i + "_" + j,
          "reelsParticleLayer",
          {
            definition: "wildBlast",
            x: posX,
            y: posY,
            anchor: 0.5,
            scale: 2,
            loop: false,
          }
        );

        movie.gotoAndStop(0);
        wild.gotoAndStop(0);

        rowAnims.push(movie);
        wildRowAnims.push(wild);
      }

      _symbolDisappearAnims.push(rowAnims);
      _wildBlastAnims.push(wildRowAnims);
    }
  };

  gameController.getExplosionAnims = function () {
    return _symbolDisappearAnims;
  };

  gameController._receivedResponse = false;

  // State Machine //

  StateMachine.Create(gameController);

  gameController.stateMachine.addState("WAITING_FOR_SERVER", function () {});

  gameController.stateMachine.addState("WAIT_FOR_START", function () {
    if (gameController.phase.once()) {
      resourceManager.getController("autoplayController").checkLimits();
    }
    if (gameController.phase.hold()) {
      if (!resourceManager.getController("autoplayController").LimitPopupOpen) {
        gameController.phase.step();
      }
    }
    if (gameController.phase.hold()) {
      // Waiting for player to do something
      if (autoplayManager.isAutoplayEnabled()) {
        if (
          autoplayManager.AP.getFields()["numberOfRounds"].currentValue !==
          autoplayManager.AP.roundsRemaining()
        ) {
          var timeToNext = 500;
          resourceManager.getController(
            "autoplayController"
          ).timeToNextAutoplay = timeToNext;
          gameController.phase.step();
        }
      }
    }
    if (
      gameController.phase.timed(
        resourceManager.getController("autoplayController").timeToNextAutoplay
      )
    ) {
      if (!autoplayManager.isAutoplayEnabled()) {
        gameController.phase.reset();
      }
    }
    if (gameController.phase.once()) {
      startGame();
    }
  });

  gameController.initialDropComplete = function (reelID) {
    --_initialDropping;
  };

  gameController.stateMachine.addState("CLEAR_REELS", function () {
    // when reels have cleared we can drop in new positions
    // clear reels has a callback to reduce reelsDropping count
    if (gameController.phase.enter()) {
      _initialDropping = gameData.reels.length;

      gameController.hideOverlay();
    }

    // TODO 23/05/22 this needs to hold until all initial reels are dropped AND the spin task has been received
    if (gameController.phase.hold()) {
      if (_initialDropping === 0) {
        gameController.phase.step();
      }
    }

    // drop intial symbols needs to have finished before we do spin task leave and the symbols should all have landed
    if (gameController.phase.once()) {
      //gameController.stateMachine.switchState("REELS_SPINNING");
      gameController.stateMachine.switchState("DROP_INITIAL_SYMBOLS");
    }
  });

  gameController.stateMachine.addState("DROP_INITIAL_SYMBOLS", function () {
    if (gameController.phase.hold()) {
      // don't proceed unless we receive the spin task
      if (gameController.spinTask !== undefined) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      _reelsSpinning = [true, true, true, true, true];
      _symbolCallbackFired = [];

      logoIdleTimeline.pause();

      let _positions = gameController.spinTask.data.resultPanel.reelList.map(
        function (reel, index) {
          return reel.symbols.map(function (curr) {
            return curr.value;
          });
        }
      );

      // we need to have a random symbol as the first below which we can drop
      // off the symbol grid when new symbols all cascade in
      let randomBelow = [];
      let allowedSymbols = [0, 1, 2, 3, 4, 5, 6, 7]; // no 8 or 9 as we don't want wilds or a bonus to appear
      for (var i = 0; i < gameData.reels.length; i++) {
        randomBelow[i] = allowedSymbols[getRandom(allowedSymbols.length)];
      }

      let _symbolsAbove = [[0], [0], [0], [0], [0]];
      let _symbolsBelow = [
        [randomBelow[0]],
        [randomBelow[1]],
        [randomBelow[2]],
        [randomBelow[3]],
        [randomBelow[4]],
      ];

      // calculate whether we display landing symbols
      gameController.calcLandingAnims();

      // now drop the symbols in
      slotMachine.dropInitialSymbols(_symbolsAbove, _positions, _symbolsBelow);

      gameController.addOversizedSymbols();
    }

    if (gameController.phase.once()) {
      gameController._receivedResponse = true; // this allows slam stop
    }

    // don't proceed until all reels have finished spinning
    if (gameController.phase.hold()) {
      // check for any reels still spinning
      var spinComplete = true;
      for (
        var spinningIdx = 0;
        spinningIdx < _reelsSpinning.length;
        spinningIdx++
      ) {
        spinComplete = spinComplete && !_reelsSpinning[spinningIdx];
      }

      if (spinComplete) {
        gameController.phase.step();
        gameController._receivedResponse = false;
      }
    }

    // wait for all landing anims to finish playing
    if (gameController.phase.hold()) {
      let anyPlaying = false;
      for (var i = 0; i < _landedAnimsPlaying.length; i++) {
        let reelID = _landedAnimsPlaying[i][0];
        let row = _landedAnimsPlaying[i][1];

        let animStrip = resourceManager.get(
          reelManager.reels[reelID].linkedAnimations[0].name
        );
        if (animStrip.isAnimationPlaying(row)) {
          anyPlaying = true;
        }
      }

      // all landing anims finished - hide them away
      if (!anyPlaying) {
        for (var i = 0; i < _landedAnimsPlaying.length; i++) {
          let reelID = _landedAnimsPlaying[i][0];
          let row = _landedAnimsPlaying[i][1];

          let animStrip = resourceManager.get(
            reelManager.reels[reelID].linkedAnimations[0].name
          );
          animStrip.hideAnimation(row);
        }

        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      if (gameController.spinTask) {
        gameController.spinTask.leave();
      }
    }
  });

  // handle the anims on landing - cascadeInfiniReels calls this callback
  // then we match up if it's a valid bonus symbol to play anim/sound
  gameController.onSymbolLandedCallback = function (landedReel, landedRow) {
    var bonusLanded = false;

    // check that we have't already fired this callback ( can be retriggered doing a slam stop )
    for (var i = 0; i < _symbolCallbackFired.length; i++) {
      var firedReel = _symbolCallbackFired[i][0];
      var firedRow = _symbolCallbackFired[i][1];

      // if we've already fired this callback don't do it again
      if (landedReel === firedReel && landedRow === firedRow) {
        return;
      }
    }

    // we've got here so this must be the first time we've fired this callback - add to array
    _symbolCallbackFired.push([landedReel, landedRow]);

    // play landing anims as required
    for (var i = 0; i < _landedAnimsPlaying.length; i++) {
      var reel = _landedAnimsPlaying[i][0];
      var row = _landedAnimsPlaying[i][1];

      if (landedReel === reel && landedRow === row) {
        soundManager.play(_spinBonusSounds[reel]);

        bonusLanded = true;
      }
    }

    // if we didn't play a sound on landing play it here - might need a different sound
    // don't play it on slam stop else the sounds all clash together
    if (!bonusLanded) {
      let rand = Math.floor(Math.random() * 8) + 1;
      soundManager.play(`symbolLand_${rand}`);
    }
  };

  // Here we amend the layering for any oversized symbols so they're always on top
  gameController.addOversizedSymbols = function () {
    for (var l = 0; l < 3; l++) {
      for (let i = 0; i < 5; i++) {
        if (gameData.reels[i].symbolData[l].symbolId == 13) {
          // 13 = oversized bonus symbol
          gameData.reels[i].overlayOversizedSymbols(l);
        }
      }
    }
  };

  gameController.calcLandingAnims = function () {
    var bonusID = resourceManager.getConfiguration().symbols["Bonus"].ID;

    _landedAnimsPlaying = [];
    _bonusSymbolsLanded = 0;

    // this assumes we only get one bonus symbol visible per reel
    for (var reelID = 0; reelID < reelManager.reels.length; reelID++) {
      var found = false;
      var foundRow = -1;

      for (var i = 0; i < 3; i++) {
        if (
          gameController.spinTask.data.resultPanel.reelList[reelID].symbols[i]
            .value === bonusID
        ) {
          found = true;
          foundRow = i;
        }
      }

      // only play the sound/anim if it's possible to activate enough bonus symbols
      if (found) {
        if (_bonusSymbolsLanded >= reelID - 2) {
          // save reel/row
          _landedAnimsPlaying.push([reelID, foundRow]);
        }

        _bonusSymbolsLanded++;
      }
    }
  };

  // when reel has landed all symbols - mark as no longer spinning
  gameController.onSpinCompleteBase = function (reelID) {
    _reelsSpinning[reelID] = false;
  };

  gameController.stateMachine.addState("REELS_SPINNING", function () {
    if (gameController.phase.enter()) {
      _reelsSpinning = [true, true, true, true, true];
    }

    if (gameController.phase.once()) {
    }

    if (gameController.phase.exit()) {
      // If the game has aborted the spin task will be undefined
      if (gameController.spinTask) {
        gameController.spinTask.leave();
      }
    }
  });

  gameController.stateMachine.addState("PAYWINS", function () {
    if (gameController.phase.once()) {
      gameController.showOverlay();

      _groupWinAmount = 0;
      _groupWinCount = 0;

      _animWinsFinished = false;
      _singleAnimWinFinished = false;

      if (_payWinsEvent?.data?.leftMultiplierInc > 0) {
        frameArrows.showArrows("left");
        multiplierViewLeft.startMultiplierAnim();
        multiplierViewLeft.pulseMultiplierWinTxtTween();
      }

      if (_payWinsEvent?.data?.rightMultiplierInc > 0) {
        frameArrows.showArrows("right");
        multiplierViewRight.startMultiplierAnim();
        multiplierViewRight.pulseMultiplierWinTxtTween();
      }

      soundManager.play("winMultiplied");
    }

    if (gameController.phase.once()) {
      _animWinsFinished = false;
      _singleAnimWinFinished = false;

      AllWaysPayWinAnimator.animate(
        _payWinsEvent.data,
        function () {
          _animWinsFinished = true;
        },
        function () {
          _singleAnimWinFinished = true;
        }
      );
    }

    if (gameController.phase.hold()) {
      if (
        _singleAnimWinFinished ||
        (!gameController.canCelebrate && !freespins.inFreespins)
      ) {
        gameController.phase.step();
      }
    }

    if (gameController.canCelebrate || freespins.inFreespins) {
      if (!_payWinsEvent.data.isFinalCapped) {
        if (gameController.phase.once()) {
          soundManager.play("winCountUp");
        }

        if (gameController.phase.timed(500)) {
          var appearProgress = Math.min(0.5 + gameController.phase.Progress, 1);
          gameData.winningsText.setWinText(true);
          gameData.winningsText.show(true, 0);
          gameData.winningsText.setScale(appearProgress);
          gameData.winningsText.alpha = appearProgress;
          gameData.winningsText.setText(
            Math.floor(
              gameController.phase.Progress *
                _payWinsEvent.data.totalLineWinnings
            )
          );

          if (_skipWin) {
            gameController.phase.step();
          }
        }

        if (gameController.phase.once()) {
          soundManager.stop("winCountUp");
          soundManager.play("winCountUpEnd");
          gameData.winningsText.playDiamondAnimation();
          gameData.winningsText.setScale(1);
          gameData.winningsText.alpha = 1;
          gameData.winningsText.setText(
            Math.floor(_payWinsEvent.data.totalLineWinnings)
          );
        }

        if (gameController.phase.timed(900)) {
        }
      }
    } else {
      if (gameController.phase.timed(400)) {
        _animWinsFinished = true;
      }
    }

    if (gameController.phase.hold()) {
      gameController.phase.step();
    }

    if (gameController.phase.once()) {
      if (
        _payWinsEvent.data.payWaysLeft.payWaysWins.length > 0 ||
        _payWinsEvent.data.payWaysRight.payWaysWins.length > 0 ||
        _payWinsEvent.data.payWays5X.payWaysWins.length > 0
      ) {
        gameController.stateMachine.switchState("AWARD_MULTIPLIER");
      } else {
        gameController.stateMachine.switchState("PRE_POP_SYMBOLS");
      }
    }

    if (gameController.phase.exit()) {
    }
  });

  gameController.skipWins = function () {
    _skipWin = true;
  };

  gameController.stateMachine.addState("AWARD_MULTIPLIER", function () {
    if (gameController.phase.once()) {
      gameController.stateMachine.switchState("PRE_POP_SYMBOLS");
    }
  });

  gameController.showOverlay = function () {
    if (darkOverlay === undefined) return;

    if (darkOverlayShowing) return;

    darkOverlayShowing = true;
    darkOverlay.visible = true;
    darkOverlay.alpha = 0;

    gsap.to(darkOverlay, {
      duration: 0.4,
      alpha: 0.3,
    });
  };

  gameController.hideOverlay = function () {
    if (darkOverlay === undefined) return;

    if (!darkOverlayShowing) return;

    darkOverlayShowing = false;

    gsap.to(darkOverlay, {
      duration: 0.4,
      alpha: 0,
      onComplete: () => {
        darkOverlay.visible = false;
      },
    });
  };

  gameController.stateMachine.addState("PRE_POP_SYMBOLS", function () {
    if (gameController.canCelebrate || freespins.inFreespins) {
      if (gameController.phase.timed(200)) {
        gameData.winningsText.setScale(
          1 + Math.sin(gameController.phase.Progress * Math.PI) * 0.2
        );
      }

      if (gameController.phase.timed(200)) {
        gameData.winningsText.setScale(1 - gameController.phase.Progress);
      }
    } else {
      if (gameController.phase.timed(100)) {
      }
    }

    if (gameController.phase.once()) {
      gameData.winningsText.setScale(1);
      gameData.winningsText.setText(
        Math.floor(
          gameController.phase.Progress * _payWinsEvent.data.totalLineWinnings
        )
      );

      if (!_payWinsEvent.data.isFinalCapped) {
        gameData.winningsMeter.countUp(
          _payWinsEvent.data.totalLineWinnings,
          200
        );
      }

      /**
       * Pop all symbols
       * Loop here:
       * Process pay ways in payWaysLeft, payWaysRight and payWays5X.
       **/

      _poppingSymbols = [];

      /**
       * Pays Left
       */
      for (
        var winsLeft = 0;
        winsLeft < _payWinsEvent.data.payWaysLeft.payWaysWins.length;
        winsLeft++
      ) {
        for (
          var ways = 0;
          ways <
          _payWinsEvent.data.payWaysLeft.payWaysWins[winsLeft].winSymPositions
            .length;
          ways++
        ) {
          _poppingSymbols.push({
            reel: _payWinsEvent.data.payWaysLeft.payWaysWins[winsLeft]
              .winSymPositions[ways].reel,
            row: _payWinsEvent.data.payWaysLeft.payWaysWins[winsLeft]
              .winSymPositions[ways].row,
          });
        }
      }

      /**
       * Pays Right
       */
      for (
        var winsRight = 0;
        winsRight < _payWinsEvent.data.payWaysRight.payWaysWins.length;
        winsRight++
      ) {
        for (
          var ways = 0;
          ways <
          _payWinsEvent.data.payWaysRight.payWaysWins[winsRight].winSymPositions
            .length;
          ways++
        ) {
          _poppingSymbols.push({
            reel: _payWinsEvent.data.payWaysRight.payWaysWins[winsRight]
              .winSymPositions[ways].reel,
            row: _payWinsEvent.data.payWaysRight.payWaysWins[winsRight]
              .winSymPositions[ways].row,
          });
        }
      }

      /**
       * Pay Ways 5x
       */
      for (
        var wins5x = 0;
        wins5x < _payWinsEvent.data.payWays5X.payWaysWins.length;
        wins5x++
      ) {
        for (
          var ways = 0;
          ways <
          _payWinsEvent.data.payWays5X.payWaysWins[wins5x].winSymPositions
            .length;
          ways++
        ) {
          _poppingSymbols.push({
            reel: _payWinsEvent.data.payWays5X.payWaysWins[wins5x]
              .winSymPositions[ways].reel,
            row: _payWinsEvent.data.payWays5X.payWaysWins[wins5x]
              .winSymPositions[ways].row,
          });
        }
      }

      /**
       * End Of pays loop
       */

      gameData.winningsText.show(false);

      gameController.hideOverlay();

      gameController.stateMachine.switchState("WAITING_FOR_SERVER");

      _payWinsEvent.leave();
    }
  });

  gameController.stateMachine.addState("DROP_SYMBOLS", function () {
    if (gameController.phase.enter()) {
      if (
        _dropEvent.data.extraLivesFinal <= gameController.totalExtraLives &&
        gameController.extraLiveActive
      ) {
        extraLifePopup.visible = true;
        extraLifePopup.scale.x = 0;
        extraLifePopup.scale.y = 0;

        gsap
          .timeline()
          .to(extraLifePopup.scale, {
            duration: 0.35,
            x: 1.2,
            y: 1.2,
            ease: "power4.out",
            yoyo: true,
            repeat: 1,
          })
          .call(() => {
            messageBus.post("ExtraLife:hideAnimation");
            soundManager.play("extraLifeExplode");
          })
          .call(() => {
            extraLifePopup.visible = false;
            extraLifePopup.scale.x = 0;
            extraLifePopup.scale.y = 0;
          });
      }
    }

    if (gameController.phase.timed(250)) {
    }

    if (gameController.phase.timed(500)) {
      if (
        !(_dropEvent.data.extraLivesFinal <= gameController.totalExtraLives) &&
        !gameController.extraLiveActive
      ) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      _wildAppearSymbols = [];
      _wildsToShow = [];
      _wildTypeToShow = -1; //<--- NOTE -1 ARE THE SYMBOLS TO POP NOT THE WILDS
      _dropsRemaining = 5;

      gameController.extraLiveActive = false; //we need this because we don't want to activate the trail

      if (!_modifierEventTriggered) {
        // Increase multipliers
        if (_payWinsEvent?.data?.leftMultiplierInc > 0) {
          multiplierViewLeft.increaseMultiplier();
        }

        if (_payWinsEvent?.data?.rightMultiplierInc > 0) {
          multiplierViewRight.increaseMultiplier();
        }
      }
    }

    if (gameController.phase.timed(400)) {
    }

    if (gameController.phase.once()) {
      if (!_modifierEventTriggered) {
        resourceManager
          .get("trail:TrailContainer")
          .animateTrail(
            _dropEvent.data.specialReward,
            _dropEvent.data.trailCount
          );
      }
    }

    if (gameController.phase.timed(1000)) {
    }

    if (gameController.phase.timed(2500)) {
      if (!_specialEvent) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      if (_dropEvent?.data?.specialReward?.type === "ExtraLive") {
        gameController.extraLiveActive = true;
      }

      var slotMachine = GameSlotMachineFactory.getSlotMachine(0);
      _reelToFrespinsBarFlying = 0;
      _popData = [];
      _allPopsComplete = false;

      for (var reel = 0; reel < reelManager.reels.length; ++reel) {
        var popData = [];
        var totalDropping = 0;

        for (var row = 0; row < 3; ++row) {
          popData.push(_dropEvent.data.tumbleData[reel][row] !== 0);

          if (popData[row]) {
            totalDropping++;

            if (!_modifierEventTriggered) {
              _symbolDisappearAnims[reel][row].gotoAndPlay(0);
            }

            _allPopsComplete = true;
          }
        }

        if (_dropEvent.data.extraWild) {
          for (let i = 0; i < _dropEvent.data.extraWild.length; i++) {
            let cell = _dropEvent.data.extraWild[i];

            if (cell.reel === reel) {
              var cellReel = cell.reel;
              var cellRow = cell.row;

              _wildBlastAnims[cellReel][cellRow].gotoAndPlay(0);

              gameData.reels[cellReel].growSymbol(cellRow);
            }
          }
        }

        /**
         * Add a fake pop for the wild
         */
        if (_dropEvent.data.cells) {
          let cell = _dropEvent.data.cells;

          if (cell.reel === reel) {
            var reel = cell.reel;
            var row = cell.row;

            var wildReel = reel;
            var wildRow = row;
            if (!_modifierEventTriggered) {
              gameData.reels[wildReel].showSymbol(wildRow, false);

              _wildBlastAnims[reel][row].gotoAndPlay(0);

              gameData.reels[reel].growSymbol(row);

              _symbolDisappearAnims[wildReel][wildRow].onComplete =
                function () {
                  if (gameController.phase.timed(250)) {
                  }
                };
            }
          }
        }

        gameController.addOversizedSymbols();

        // Tell reels to pop (wait for drop)
        _popData.push(popData);

        // Use this to pop symbols off TODO SA 05/04 -1 means remove symbol array
        slotMachine.reels[reel].popSymbols(
          popData,
          _dropEvent.data.window[reel]
        );
      }
      if (!_modifierEventTriggered) {
        soundManager.play("explode");
      }
    }

    if (gameController.phase.hold()) {
      if (_allPopsComplete) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(500)) {
      if (_modifierEventTriggered) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.timed(1500)) {
      if (!_specialEvent) {
        gameController.phase.step();
      }
    }

    if (gameController.phase.once()) {
      if (_specialEvent) {
        resourceManager.get("trail:TrailContainer").trailRunEnded();
      }

      // Drop symbols
      const tempPopData = _popData;
      let delayTime = 250;
      let delayIndex = 0;

      _modifierEventTriggered = false;
      _popData = [];
      _specialEvent = false;

      for (var i = 0; i < tempPopData.length; i++) {
        gameData.reels[i].dropSymbols(
          delayTime * delayIndex,
          tempPopData[i],
          onDropComplete
        );

        // Only set a delay on the next reel if this one had a drop
        if (tempPopData[i][0] || tempPopData[i][1] || tempPopData[i][2]) {
          delayIndex++;
        }
      }

      for (let reel = 0; reel < reelManager.reels.length; ++reel) {
        if (tempPopData[reel] !== undefined) {
          for (let row = 0; row < 3; ++row) {
            if (tempPopData[reel][row]) {
              gameData.reels[reel].showSymbol(row, true);
            }
          }
        }
      }
    }

    if (gameController.phase.exit()) {
    }
  });

  gameController.stateMachine.addState("PAY_TO_WINNINGS", function () {
    // Hide any bonus syms we've added, as they appear on top of the winnings view
    for (var i = 0; i < _landedAnimsPlaying.length; i++) {
      let reelID = _landedAnimsPlaying[i][0];
      let row = _landedAnimsPlaying[i][1];

      let animStrip = resourceManager.get(
        reelManager.reels[reelID].linkedAnimations[0].name
      );
      animStrip.hideAnimation(row);
      animStrip.removeChildren();
    }

    if (gameController.phase.once()) {
      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState("payToWinnings");

        let isBigWin = _bigWin.willTriggerBigWin(
          _popAndDropCompleteEvent.data.winnings
        );

        var amount =
          _popAndDropCompleteEvent.data.totalWinnings -
          gameData.winningsMeter.value;
        var isCapped = _payWinsEvent.data.isCapped;

        if (isCapped) {
          gameData.winningsMeter.countUp(amount, 500);
        }

        if (isBigWin) {
          _bigWin.start(
            _popAndDropCompleteEvent.data.totalWinnings,
            undefined,
            isCapped
          );
        }
      }
    }

    if (gameController.phase.hold()) {
      if (!_bigWin.isBigWinActive()) {
        gameController.phase.step();
      }
    }

    if (
      (gameController.canCelebrate &&
        !_bigWin.willTriggerBigWin(_popAndDropCompleteEvent.data.winnings)) ||
      (freespins.inFreespins &&
        !_bigWin.willTriggerBigWin(_popAndDropCompleteEvent.data.winnings))
    ) {
      if (gameController.phase.timed(200)) {
      }

      if (gameController.phase.once()) {
        for (var i = 0; i < reelManager.reels.length; i++) {
          reelManager.reels[i].dimAllSymbols(true, 0x666666);
        }

        gameData.winningsText.setWinText(false); // uses 'total win' instead of 'win'
        gameData.winningsText.show(true, 0);
        soundManager.play("winCountUp");
      }

      // grow to size and count up
      if (gameController.phase.timed(800)) {
        var appearProgress = Math.min(0.1 + gameController.phase.Progress, 1);
        gameData.winningsText.setScale(appearProgress);
        gameData.winningsText.alpha = appearProgress;
        gameData.winningsText.setText(
          Math.floor(gameController.phase.Progress * (_totalWinnings / 2))
        );
      }

      if (gameController.phase.timed(800)) {
        gameData.winningsText.setText(
          Math.floor(
            (gameController.phase.Progress * _totalWinnings) / 2 +
              _totalWinnings / 2
          )
        );
      }

      if (gameController.phase.once()) {
        gameData.winningsText.playDiamondAnimation();
        soundManager.stop("winCountUp");
        soundManager.play("winCountUpEnd");

        gameData.winningsText.setScale(1);
        gameData.winningsText.alpha = 1;
        gameData.winningsText.setText(
          Math.floor(gameController.phase.Progress * _totalWinnings)
        );
      }

      if (gameController.phase.timed(1500)) {
      }

      if (gameController.phase.timed(500)) {
        gameData.winningsText.alpha = 1 - gameController.phase.Progress;
      }

      if (gameController.phase.once()) {
        gameData.winningsText.show(false);
        gameData.winningsText.alpha = 1;
        for (var i = 0; i < reelManager.reels.length; i++) {
          reelManager.reels[i].dimAllSymbols(false);
        }
      }
    }

    if (gameController.phase.once()) {
      if (freespins.inFreespins) {
        musicManager.freeSpinsNextLevel();
      }

      soundManager.stop("winCountUp");

      gameData.winningsMeterTitle.visible = true;
    }

    if (gameController.phase.timed(300)) {
    }

    if (gameController.phase.once()) {
      gameController.stateMachine.switchState("WAITING_FOR_SERVER");
    }

    if (gameController.phase.exit()) {
      if (!freespins.inFreespins) {
        gameData.inputOverlord.setState("enabled");
      }

      _popAndDropCompleteEvent.leave();
    }
  });

  gameController.stateMachine.addState("END_GAME", function () {
    if (gameController.phase.once()) {
      gameController.hideOverlay();
      logoIdleTimeline.play();

      messageBus.post("ExtraLife:reset");

      updateStake();

      // End of game cycle
      gdk.endGame(function () {
        _dropEvent = [];
        _payWinsEvent = [];
        gameController.stateMachine.switchState("WAIT_FOR_START");
      });
    }
  });

  gameController.initialise = function () {
    _bigWin = resourceManager.get("bigWin");
    _bigWin.init();
    freespins.initialise();
    multiplierViewLeft = resourceManager.get(
      "multiplierViewLeft:MultiplierViewLeft"
    );
    multiplierViewRight = resourceManager.get(
      "multiplierViewRight:MultiplierViewRight"
    );
    frameArrows = resourceManager.get("frameArrowsAnimsView");
    _freeSpinsMeter = resourceManager.get("freeSpinsMeter");
    _freeSpinsMeter.initialise();

    titleAnim = resourceManager.get("logoContainer:logo");
    titleAnim.visible = true;

    extraLifePopup = resourceManager.get(
      "extraLifePopupContainer:extraLifePopup"
    );
    extraLifePopup.visible = false;

    logoIdleTimeline = gsap.timeline({ repeat: -1 }).call(
      () => {
        titleAnim.gotoAndPlay(0);
      },
      undefined,
      "<+=4"
    );
    logoIdleTimeline.play();

    const slamStopButton = resourceManager.get(
      "buttonContainer:buttonBar:slamStopButton"
    );
    slamStopButton.canEnableBase = slamStopButton.canEnable;
    slamStopButton.canEnable = function () {
      return this.canEnableBase() && gameController._receivedResponse;
    };

    const volumeButton = resourceManager.get("buttonContainer:buttonBar:mute");
    volumeButton.canShowBase = volumeButton.canShow;
    volumeButton.canShow = function () {
      return this.canShowBase() && settingsMenu.buttons.btnSound.visible;
    };

    resourceManager.get(
      "buttonContainer:buttonBar:autoplayButton:glow"
    ).visible = false;

    darkOverlay = resourceManager.get("darkOverlay");
    darkOverlay.beginFill(0x000000);
    darkOverlay.lineStyle(0, 0x000000);
    darkOverlay.drawRect(0, 0, 1900, 1900);
    darkOverlay.visible = false;
    darkOverlayShowing = false;

    gameController.setupSymbolDisappearAnims();

    musicManager.onGameLoaded();
  };

  gameController.getIsRecovery = function () {
    return inRecovery;
  };

  gameController.globalHelperGetStake = function () {
    let stake = resourceManager.getController("stakeController").BaseStake;
    if (gameController.inBuyABonus) {
      stake *= 100;
    }

    return stake;
  };

  ///////////////////
  // subscriptions //
  ///////////////////

  messageBus.subscribe("common:GameCompleteEvent", preGameComplete);
  messageBus.subscribe("autoplay:started", autoplayStarted);
  messageBus.subscribe("autoplay:ended", autoplayEnded);
  messageBus.subscribe("spinner:SpinEvent", gameController.onSpinEvent);
  messageBus.subscribe("spinner:WinningLinesEvent", doPayWins);
  messageBus.subscribe("game:DropEvent", onDropEvent);
  messageBus.subscribe("game:ModifierEvent", onModifierEvent);
  messageBus.subscribe("game:PopAndDropComplete", onPopAndDropComplete);
  //messageBus.subscribe("game:PopAndDropComplete", hideBonusSyms);
  // messageBus.subscribe("game:RespinEvent", onRespinIntro);
  // messageBus.subscribe("game:RespinEventDead", onRespinEvent);
  messageBus.subscribe("common:RecoverGame", recoverGame);
  messageBus.subscribe("common:JackpotGame", jackpotGame);
  messageBus.subscribe("platform:startNextGame", startGame);
  messageBus.subscribe("common:AbortGame", onAbortGame);
  messageBus.subscribe("game:ExtraSpinsRemaining", onExtraSpinsRemaining);
  messageBus.subscribe("game:FreeSpinsAwardEvent", onFeatureAnnounced);
  messageBus.subscribe("game:FreeSpinsEndEvent", onFeatureEnded);

  Reflex.addToUpdate(update.bind(gameController));

  messageBus.subscribe("common:PromotionStarted", onPromotionStarted);
  messageBus.subscribe("common:PromotionEnded", onPromotionEnded);

  gameController.canCelebrate = true;
  gameController.extraLiveActive = false;
  gameController.multipliersComplete = false;
  gameController.extraLifeUsed = false;
  gameController.totalExtraLives = 0;

  gameController.stateMachine.switchState("WAIT_FOR_START");

  Object.seal(gameController);

  return gameController;
})();
